import React, { useEffect, useState, useRef } from 'react'
import './Counters.scss'
import { useLanguage } from '../Contexts/LanguageContext'

const Counter = ({ target, duration, interval, start }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!start) return;
        let startValue = 0;
        const end = target;
        const increment = end / (duration / interval);
        const timer = setInterval(() => {
            startValue += increment;
            if (startValue >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(startValue));
            }
        }, interval);
        return () => clearInterval(timer);
    }, [target, duration, interval, start]);

    return <h2>{count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</h2>;
};

const Counters = () => {
    const [startCounting, setStartCounting] = useState(false);
    const countersRef = useRef(null);
    const { language } = useLanguage();


    useEffect(() => {
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartCounting(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.6 }
        );
        if (countersRef.current) {
            observer.observe(countersRef.current);
        }
        return () => observer.disconnect();
    }, []);

    return (
        <div className='counters' ref={countersRef}>
            <h2 className='title'>{language === 'polish' ? 'Obsługujemy ponad' : 'We support over'}</h2>
            <div className='counters-container'>
                <div className='counter-one'>
                    <Counter target={5000} duration={1000} interval={1} start={startCounting} />
                    <h3>{language === 'polish' ? 'Kanałów' : 'Channels'}</h3>
                </div>
                <div className='counter-two'>
                    <Counter target={7000} duration={1500} interval={1} start={startCounting} />
                    <h3>{language === 'polish' ? 'Mini Aplikacji' : 'Mini Apps'}</h3>
                </div>
            </div>
        </div>
    )
}

export default Counters